import React from 'react';

export default function Navbar() {
  return (
    <div className="hybrid-title">
      <b>Tracker Elite</b>
    </div>
  );
}
